/* tslint:disable */
/* eslint-disable */
/**
 * School Reporting Systems API
 * School Reporting Systems.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: tony.henderson@elevenfiftynine.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SchoolCohortRequest } from '../model';
// @ts-ignore
import { SchoolCohortResponse } from '../model';
// @ts-ignore
import { SchoolDesignatedContactRequest } from '../model';
// @ts-ignore
import { SchoolDesignatedContactResponse } from '../model';
// @ts-ignore
import { SchoolInformationRequest } from '../model';
// @ts-ignore
import { SchoolInformationResponse } from '../model';
// @ts-ignore
import { SchoolRequest } from '../model';
// @ts-ignore
import { SchoolResponse } from '../model';
/**
 * SchoolsApi - axios parameter creator
 * @export
 */
export const SchoolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolCohortRequest} [schoolCohortRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolCohortGetSchoolCohortsBySchoolCodePost: async (apiVersion?: string, schoolCohortRequest?: SchoolCohortRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SchoolCohort/GetSchoolCohortsBySchoolCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolCohortRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolCohortRequest !== undefined ? schoolCohortRequest : {})
                : (schoolCohortRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_CREATE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolDesignatedContactCreatePost: async (apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SchoolDesignatedContact/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolDesignatedContactRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolDesignatedContactRequest !== undefined ? schoolDesignatedContactRequest : {})
                : (schoolDesignatedContactRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_DELETE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolDesignatedContactDeletePost: async (apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SchoolDesignatedContact/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolDesignatedContactRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolDesignatedContactRequest !== undefined ? schoolDesignatedContactRequest : {})
                : (schoolDesignatedContactRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_GET_ALL]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodePost: async (apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SchoolDesignatedContact/GetSchoolDesignatedContactBySchoolCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolDesignatedContactRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolDesignatedContactRequest !== undefined ? schoolDesignatedContactRequest : {})
                : (schoolDesignatedContactRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_UPDATE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolDesignatedContactUpdatePost: async (apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SchoolDesignatedContact/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolDesignatedContactRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolDesignatedContactRequest !== undefined ? schoolDesignatedContactRequest : {})
                : (schoolDesignatedContactRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolGetSchoolBySchoolCodePost: async (apiVersion?: string, schoolRequest?: SchoolRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/School/GetSchoolBySchoolCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolRequest !== undefined ? schoolRequest : {})
                : (schoolRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolGetSchoolsByUserEmailPost: async (apiVersion?: string, schoolRequest?: SchoolRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/School/GetSchoolsByUserEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolRequest !== undefined ? schoolRequest : {})
                : (schoolRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_CREATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolInformationCreatePost: async (apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SchoolInformation/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolInformationRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolInformationRequest !== undefined ? schoolInformationRequest : {})
                : (schoolInformationRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolInformationGetSchoolInformationBySchoolCodePost: async (apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SchoolInformation/GetSchoolInformationBySchoolCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolInformationRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolInformationRequest !== undefined ? schoolInformationRequest : {})
                : (schoolInformationRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_UPDATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolInformationUpdatePost: async (apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SchoolInformation/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolInformationRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolInformationRequest !== undefined ? schoolInformationRequest : {})
                : (schoolInformationRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_UPDATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolUpdatePost: async (apiVersion?: string, schoolRequest?: SchoolRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/School/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof schoolRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(schoolRequest !== undefined ? schoolRequest : {})
                : (schoolRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchoolsApi - functional programming interface
 * @export
 */
export const SchoolsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolCohortRequest} [schoolCohortRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolCohortGetSchoolCohortsBySchoolCodePost(apiVersion?: string, schoolCohortRequest?: SchoolCohortRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolCohortResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolCohortGetSchoolCohortsBySchoolCodePost(apiVersion, schoolCohortRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_CREATE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolDesignatedContactCreatePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolDesignatedContactResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolDesignatedContactCreatePost(apiVersion, schoolDesignatedContactRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_DELETE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolDesignatedContactDeletePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolDesignatedContactResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolDesignatedContactDeletePost(apiVersion, schoolDesignatedContactRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_GET_ALL]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolDesignatedContactResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodePost(apiVersion, schoolDesignatedContactRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_UPDATE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolDesignatedContactUpdatePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolDesignatedContactResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolDesignatedContactUpdatePost(apiVersion, schoolDesignatedContactRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolGetSchoolBySchoolCodePost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolGetSchoolBySchoolCodePost(apiVersion, schoolRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolGetSchoolsByUserEmailPost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolGetSchoolsByUserEmailPost(apiVersion, schoolRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_CREATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolInformationCreatePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolInformationResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolInformationCreatePost(apiVersion, schoolInformationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolInformationGetSchoolInformationBySchoolCodePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolInformationResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolInformationGetSchoolInformationBySchoolCodePost(apiVersion, schoolInformationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_UPDATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolInformationUpdatePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolInformationResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolInformationUpdatePost(apiVersion, schoolInformationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_UPDATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSchoolUpdatePost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolResponse>> {
            const localVarAxiosArgs = await SchoolsApiAxiosParamCreator(configuration).apiSchoolUpdatePost(apiVersion, schoolRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SchoolsApi - factory interface
 * @export
 */
export const SchoolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolCohortRequest} [schoolCohortRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolCohortGetSchoolCohortsBySchoolCodePost(apiVersion?: string, schoolCohortRequest?: SchoolCohortRequest, options?: any): AxiosPromise<SchoolCohortResponse> {
            return SchoolsApiFp(configuration).apiSchoolCohortGetSchoolCohortsBySchoolCodePost(apiVersion, schoolCohortRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_CREATE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolDesignatedContactCreatePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any): AxiosPromise<SchoolDesignatedContactResponse> {
            return SchoolsApiFp(configuration).apiSchoolDesignatedContactCreatePost(apiVersion, schoolDesignatedContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_DELETE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolDesignatedContactDeletePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any): AxiosPromise<SchoolDesignatedContactResponse> {
            return SchoolsApiFp(configuration).apiSchoolDesignatedContactDeletePost(apiVersion, schoolDesignatedContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_GET_ALL]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any): AxiosPromise<SchoolDesignatedContactResponse> {
            return SchoolsApiFp(configuration).apiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodePost(apiVersion, schoolDesignatedContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_UPDATE]
         * @summary POST SchoolDesignatedContactRequest
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolDesignatedContactUpdatePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any): AxiosPromise<SchoolDesignatedContactResponse> {
            return SchoolsApiFp(configuration).apiSchoolDesignatedContactUpdatePost(apiVersion, schoolDesignatedContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolGetSchoolBySchoolCodePost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any): AxiosPromise<SchoolResponse> {
            return SchoolsApiFp(configuration).apiSchoolGetSchoolBySchoolCodePost(apiVersion, schoolRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_GET]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolGetSchoolsByUserEmailPost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any): AxiosPromise<SchoolResponse> {
            return SchoolsApiFp(configuration).apiSchoolGetSchoolsByUserEmailPost(apiVersion, schoolRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_CREATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolInformationCreatePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any): AxiosPromise<SchoolInformationResponse> {
            return SchoolsApiFp(configuration).apiSchoolInformationCreatePost(apiVersion, schoolInformationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolInformationGetSchoolInformationBySchoolCodePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any): AxiosPromise<SchoolInformationResponse> {
            return SchoolsApiFp(configuration).apiSchoolInformationGetSchoolInformationBySchoolCodePost(apiVersion, schoolInformationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_UPDATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolInformationRequest} [schoolInformationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolInformationUpdatePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any): AxiosPromise<SchoolInformationResponse> {
            return SchoolsApiFp(configuration).apiSchoolInformationUpdatePost(apiVersion, schoolInformationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_UPDATE]
         * @param {string} [apiVersion] The requested API version
         * @param {SchoolRequest} [schoolRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchoolUpdatePost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any): AxiosPromise<SchoolResponse> {
            return SchoolsApiFp(configuration).apiSchoolUpdatePost(apiVersion, schoolRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchoolsApi - object-oriented interface
 * @export
 * @class SchoolsApi
 * @extends {BaseAPI}
 */
export class SchoolsApi extends BaseAPI {
    /**
     * [BX_GET]
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolCohortRequest} [schoolCohortRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolCohortGetSchoolCohortsBySchoolCodePost(apiVersion?: string, schoolCohortRequest?: SchoolCohortRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolCohortGetSchoolCohortsBySchoolCodePost(apiVersion, schoolCohortRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_CREATE]
     * @summary POST SchoolDesignatedContactRequest
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolDesignatedContactCreatePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolDesignatedContactCreatePost(apiVersion, schoolDesignatedContactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_DELETE]
     * @summary POST SchoolDesignatedContactRequest
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolDesignatedContactDeletePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolDesignatedContactDeletePost(apiVersion, schoolDesignatedContactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_GET_ALL]
     * @summary POST SchoolDesignatedContactRequest
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolDesignatedContactGetSchoolDesignatedContactBySchoolCodePost(apiVersion, schoolDesignatedContactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_UPDATE]
     * @summary POST SchoolDesignatedContactRequest
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolDesignatedContactRequest} [schoolDesignatedContactRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolDesignatedContactUpdatePost(apiVersion?: string, schoolDesignatedContactRequest?: SchoolDesignatedContactRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolDesignatedContactUpdatePost(apiVersion, schoolDesignatedContactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_GET]
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolRequest} [schoolRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolGetSchoolBySchoolCodePost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolGetSchoolBySchoolCodePost(apiVersion, schoolRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_GET]
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolRequest} [schoolRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolGetSchoolsByUserEmailPost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolGetSchoolsByUserEmailPost(apiVersion, schoolRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_CREATE]
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolInformationRequest} [schoolInformationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolInformationCreatePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolInformationCreatePost(apiVersion, schoolInformationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_GET_ALL]
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolInformationRequest} [schoolInformationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolInformationGetSchoolInformationBySchoolCodePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolInformationGetSchoolInformationBySchoolCodePost(apiVersion, schoolInformationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_UPDATE]
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolInformationRequest} [schoolInformationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolInformationUpdatePost(apiVersion?: string, schoolInformationRequest?: SchoolInformationRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolInformationUpdatePost(apiVersion, schoolInformationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_UPDATE]
     * @param {string} [apiVersion] The requested API version
     * @param {SchoolRequest} [schoolRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    public apiSchoolUpdatePost(apiVersion?: string, schoolRequest?: SchoolRequest, options?: any) {
        return SchoolsApiFp(this.configuration).apiSchoolUpdatePost(apiVersion, schoolRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
